"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Reselect = require("reselect");
var widgets_1 = require("@tableau/widgets");
var widgets_datagrid_1 = require("@tableau/widgets-datagrid");
var IndentedCellWithExpansionIndicator_1 = require("./dataGridCells/IndentedCellWithExpansionIndicator");
function getSelectionData(selectedItemId) {
    var _a;
    if (!selectedItemId) {
        return {};
    }
    else {
        return _a = {}, _a[selectedItemId] = true, _a;
    }
}
function buildColumnSpec(cellFormatter, selectRowOnExpansion) {
    return {
        name: TreeViewComponent.ColumnName,
        dataKey: '',
        headerText: '',
        growToFit: true,
        cellFormatter: React.createFactory(IndentedCellWithExpansionIndicator_1.IndentedCellWithExpansionIndicatorComponent(cellFormatter, selectRowOnExpansion)),
        cellStyle: {
            paddingLeft: widgets_1.TabStyles.Spacing.SmallSpace,
            paddingRight: 0
        }
    };
}
// This can't be a pure component because the expanded item key state lives inside the row store.
var TreeViewComponent = /** @class */ (function (_super) {
    __extends(TreeViewComponent, _super);
    function TreeViewComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.memoizedGetSelectionData = Reselect.defaultMemoize(getSelectionData);
        return _this;
    }
    TreeViewComponent.prototype.render = function () {
        // Make sure that the selected item is visible
        var focusedRowIndex;
        if (this.props.selectedItemId) {
            if (this.props.keepSelectedItemFocusedAndParentsExpanded) {
                this.props.rowStore.expandParentsOfItemKey(this.props.selectedItemId);
                focusedRowIndex = this.props.rowStore.getRowIndex(this.props.selectedItemId);
            }
        }
        var dataGridProps = {
            rowStore: this.props.rowStore,
            hackyUpdate: 0,
            showHeaders: false,
            showHorizontalGridLines: false,
            cols: [buildColumnSpec(this.props.cellFormatter, this.props.selectRowOnExpansion)],
            onCellClick: this.props.onItemClicked,
            onRowClick: this.props.onItemClicked,
            config: {
                rowOuterHeight: TreeViewComponent.RowHeight
            },
            requestedFocusedRowIndex: focusedRowIndex,
            selectionData: this.memoizedGetSelectionData(this.props.selectedItemId)
        };
        return React.createElement(widgets_datagrid_1.DataGrid, __assign({}, dataGridProps));
    };
    return TreeViewComponent;
}(React.Component));
exports.TreeViewComponent = TreeViewComponent;
(function (TreeViewComponent) {
    TreeViewComponent.RowHeight = widgets_1.TabStyles.Sizing.RowHeight;
    TreeViewComponent.ColumnName = 'name-col';
    TreeViewComponent.ExpansionIndicatorTestId = IndentedCellWithExpansionIndicator_1.ExpansionIndicatorTestId;
})(TreeViewComponent = exports.TreeViewComponent || (exports.TreeViewComponent = {}));
exports.TreeViewComponent = TreeViewComponent;
//# sourceMappingURL=TreeViewComponent.js.map